/* 
Objects of class Entry represent listings of individual species in the field guide.
*/


class Entry {
    constructor(id, species, name, clade, rarity, threatStatus, habitat, diet, description, photo1, photo1credit, photo2, photo2credit) {
        this.id = id;                       // first two chars of genus + first two chars of species
        this.species = species;             // scientific name
        this.name = name;                   // common name
        this.clade = clade;                 // class
        this.rarity = rarity;               // rarity imo, int between 1 (least rare) and 3 (most rare)
        this.threatStatus = threatStatus;   // bool
        this.habitat = habitat;             // campus habitat description
        this.diet = diet;                   // brief dietary description
        this.description = description;     // physical description, behaviors
        this.photo1 = photo1;               // adult photo, primary image
        this.photo1credit = photo1credit;   // credit for photo1
        this.photo2 = photo2;               // juvenile or secondary image
        this.photo2credit = photo2credit;   // credit for photo2

      }
}

export default Entry;